import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';
const API_URL = isProduction
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:5001/api');

export const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth services
export const authService = {
  login: (username, password) =>
    api.post('/auth/login', { username, password }),
  register: (username, password) =>
    api.post('/auth/register', { username, password }),
  getProfile: () => api.get('/auth/profile'),
};

// Category services
export const categoryService = {
  getAllCategories: () => api.get('/categories'),
  getCategoryById: (id) => api.get(`/categories/${id}`),
  createCategory: (formData) =>
    api.post('/categories', formData),
  updateCategory: (id, formData) =>
    api.put(`/categories/${id}`, formData),
  deleteCategory: (id) => api.delete(`/categories/${id}`),
};

// Reel services
export const reelService = {
  getAllReels: (limit = 20, offset = 0) =>
    api.get(`/reels?limit=${limit}&offset=${offset}`),
  getReelsByCategory: (categoryId, limit = 20, offset = 0) =>
    api.get(`/reels/category/${categoryId}?limit=${limit}&offset=${offset}`),
  getReelById: (id) => api.get(`/reels/by-id/${id}`),
  createReel: (formData, config = {}) =>
    api.post('/reels', formData, config),
  updateReel: (id, formData) =>
    api.put(`/reels/${id}`, formData),
  deleteReel: (id) => api.delete(`/reels/${id}`),
  getReelStats: () => api.get('/reels/stats/all'),
};
